<table class="table mb-0 table-striped">
    <thead>
        <tr *ngFor="let data of ColumnasSN">
            <td>{{data.TITULO}}</td>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let contenido of tableData">
            <tr *ngFor="let informacion of contenido.DATOS">
                <td (click)="parametros(contenido.LLAVES[0])">{{informacion.DATO}}</td>
                <td>
                    <button class="btn btn-success btn-sm btn-label waves-light" (click)="parametros(contenido.LLAVES[0])">
                        <i class="fa-solid fa-download label-icon"></i> Descargar 
                    </button>
                </td>
            </tr>
        </ng-container>
    </tbody>
</table>